'use client'

import { testIds } from '@/root/shared-consts'
import Link, { LinkProps } from 'next/link'
import { BackIcon } from '@/root/ui/shared'
import cn from 'classnames'

interface BackButtonProps extends LinkProps {
  title: string
  subtitle: string
}

export const BackLink = ({ href, title, subtitle, ...rest }: BackButtonProps) => {
  const textClass = 'text-neutral-medium-light text-end leading-tight'

  return (
    <Link
      href={href}
      data-testid={testIds.bottomNav.goToPrev}
      className="border-neutral-medium-light flex h-20 w-1/2 max-w-64 items-center justify-between rounded-2xl border px-4"
      {...rest}
    >
      <div className="size-6">
        <BackIcon color="neutral-medium-light" />
      </div>
      <div className="flex size-max flex-col flex-wrap items-end justify-around">
        <div className={cn(textClass, 'xxs:text-2xl text-xl font-bold uppercase')}>{title}</div>
        <div className={cn(textClass, 'text-sm font-semibold')}>{subtitle}</div>
      </div>
    </Link>
  )
}
